export const STRAPI_URL = process.env.REACT_APP_STRAPI_URL;
export const STRAPI_GRAPHQL = process.env.REACT_APP_STRAPI_GRAPHQL;
export const PREVIEW_URL = process.env.REACT_APP_PREVIEW_URL;
export const PREVIEW_SECRET = process.env.REACT_APP_PREVIEW_SECRET;
